import { render, staticRenderFns } from "./TgCard.vue?vue&type=template&id=a5de3dec&scoped=true&"
import script from "./TgCard.vue?vue&type=script&lang=js&"
export * from "./TgCard.vue?vue&type=script&lang=js&"
import style0 from "./TgCard.vue?vue&type=style&index=0&id=a5de3dec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5de3dec",
  null
  
)

export default component.exports